<ng-content select="[phx-card-header]"></ng-content>
<div class="phx-card-body">
  <ng-content select="[phx-card-body]"></ng-content>
  <div class="phx-card-loader" *ngIf="phxLoading">
    <ng-container *ngTemplateOutlet="phxLoadingTemplate || phxSpinner"></ng-container>
  </div>
</div>
<ng-content select="[phx-card-footer]"></ng-content>

<ng-template #phxSpinner>
  <phx-spinner [phxBackground]="phxBackground"></phx-spinner>
</ng-template>
